<template>
  <div>
    <h1>岗位匹配</h1>

    <el-dialog title="简历详情" v-model="dialogVisible" width="50%">
      <div>
        <p><strong>ID:</strong> {{ selectedResume.id }}</p>
        <p><strong>姓名:</strong> {{ selectedResume.name }}</p>
        <p><strong>邮箱:</strong> {{ selectedResume.email }}</p>
        <p><strong>联系电话:</strong> {{ selectedResume.phone }}</p>
        <p><strong>地址:</strong> {{ selectedResume.address }}</p>
        <p><strong>教育背景:</strong> {{ selectedResume.education }}</p>
        <p><strong>工作经验:</strong> {{ selectedResume.experience }}</p>
        <p><strong>专业技能:</strong> {{ selectedResume.skills }}</p>
        <p><strong>创建时间:</strong> {{ selectedResume.created_at }}</p>
        <p><strong>更新时间:</strong> {{ selectedResume.updated_at }}</p>
        <p><strong>全名:</strong> {{ selectedResume.full_name }}</p>
        <p><strong>联系电话:</strong> {{ selectedResume.phone_number }}</p>
        <p><strong>当前所在地:</strong> {{ selectedResume.location }}</p>
        <p><strong>详细工作经历:</strong> {{ selectedResume.work_experience }}</p>
        <p><strong>工作年限:</strong> {{ selectedResume.experience_years }}</p>
        <p><strong>当前职位:</strong> {{ selectedResume.current_position }}</p>
        <p><strong>当前公司:</strong> {{ selectedResume.current_company }}</p>
        <p><strong>最高学历:</strong> {{ selectedResume.education_level }}</p>
        <p><strong>教育经历:</strong> {{ selectedResume.education_history }}</p>
        <p><strong>简历源文件:</strong> <a :href="'/'+selectedResume.resume_file" target="_blank">打开</a></p>
        <p><strong>期望薪资:</strong> {{ selectedResume.expected_salary }}</p>
        <p><strong>期望职位、行业:</strong> {{ selectedResume.job_preferences }}</p>
        <p><strong>掌握的语言及熟练度:</strong> {{ selectedResume.languages }}</p>
        <p><strong>证书:</strong> {{ selectedResume.certifications }}</p>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
    <div v-if="isBusy">人才寻觅中...</div>
    <div v-else >
      <el-input v-model="resumeText" type="textarea" :rows="10" />
      <el-button type="primary" @click="submitResume">查找</el-button>
    

    </div>
    <div v-if="data">
      <hr>
      <table>
        <tr>
          <th>评测标准</th>
          <th v-for="r,i in data.people" :key="'tr-1'+i">
            {{ r.data.name }} <a href="javascript:;" @click="openResume(r.data)">查看</a>
          </th>
        </tr>
        <tr>
          <th>总分</th>
          <th v-for="r,i in data.people" :key="'tr-2'+i">
            {{ r.sum }}
          </th>
        </tr>
        <tr v-for="r,i in data.items" :key="'trx'+i">
          <th>{{ r }}</th>
          <td v-for="r2,j in data.people" :key="'td-'+i+'-'+j">
            {{ r2.score[i] }}
          </td>
        </tr>
      </table>
    </div>
  
  </div>
</template>

<script>
import { postData } from '@/api.js';

export default {
  name: 'JobManagement',
  
  data() {
    return {
      data:false,
      isBusy:false,
      selectedResume:false,
      dialogVisible: false,
      resumeText: `iOS 工程师招聘需求
职位名称：iOS 工程师
工作地点：杭州
职位类型：全职
薪资范围：4000-8000/月

岗位职责：
负责 iOS 端应用的设计、开发、优化及维护，确保高质量交付；
参与产品需求分析，提供技术可行性建议，优化用户体验；
设计并实现高效、可扩展的代码结构，提升 App 的稳定性和性能；
参与核心框架的搭建、组件化开发，提高团队开发效率；
跟进 iOS 平台的新技术发展，优化产品功能并提升用户体验；
负责线上问题的排查、修复，并持续优化应用性能。

任职要求：
计算机相关专业本科及以上学历，3 年及以上 iOS 开发经验；
熟练掌握 Swift / Objective-C，并具备良好的编码习惯；
熟悉 iOS SDK 及其核心框架（UIKit、Foundation、CoreAnimation 等）；
熟悉 多线程、网络通信、数据存储、性能优化等 关键技术；
具备良好的 架构设计能力，有 MVVM / VIPER / Redux 经验者优先；
了解 iOS 性能优化（启动速度、内存优化、电量优化、渲染优化等）；
熟悉 常见第三方库（如 RxSwift、Alamofire、SnapKit、Kingfisher 等）；
具备较强的 问题分析与调试能力，能够独立完成开发和优化工作；
具备良好的 沟通能力、团队协作能力，责任心强，对技术有热情；
有完整的 App 开发经验，或上线 App Store 的作品者优先；
了解 Flutter、React Native 或 SwiftUI 者优先。

加分项：
了解 音视频处理、图像渲染、WebRTC 等相关技术；
具备 CI/CD 自动化部署经验，熟悉 Fastlane、Jenkins；
有 TDD（测试驱动开发）经验，熟练使用 Unit Test / UI Test；
具备良好的 代码审查习惯，能主动优化团队代码质量；
有开源项目或技术博客者优先。`
    };
  },
  methods: {
    openResume(row){
      this.selectedResume = row; // 存储选中的简历信息
      this.dialogVisible = true; // 显示对话框
    },
    async submitResume() {
      try {
        this.isBusy=true;
        this.data=false;
        const response = await postData('match_resume', { resume: this.resumeText });
        this.data=response;
        this.isBusy=false
        console.log('Resume submitted successfully:', response);
      } catch (error) {
        console.error('Error submitting resume:', error);
      }
    }
  }
}
</script>

<style scoped>
/* 定义表格交替行颜色 */
table {
  width: 100%;
  border-collapse: collapse;
}

table tr:nth-child(even) {
  background-color: #f2f2f2;
}

table tr:nth-child(odd) {
  background-color: #ffffff;
}

table th, table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
</style>